import React, { useState, useEffect } from "react";
import { BackgroundContainer, LoginImage, LoginImageWrapper } from "../loginStyles";
import config from "../../../_core/config";

// Bu sayfa Prettier - Code formatter ile kaydedildiğinde görsel numaralarının yanındaki nokta siliniyor, görsel görünmüyor.
const backgroundImages = [
    `${config.awsUrlCourier}vigo-panel/1.jpg`,
    `${config.awsUrlCourier}vigo-panel/2.jpg`,
    `${config.awsUrlCourier}vigo-panel/3.jpg`,
    `${config.awsUrlCourier}vigo-panel/4.jpg`,
    `${config.awsUrlCourier}vigo-panel/5.jpg`,
    `${config.awsUrlCourier}vigo-panel/6.jpg`,
    `${config.awsUrlCourier}vigo-panel/7.jpg`,
    `${config.awsUrlCourier}vigo-panel/8.jpg`,
    `${config.awsUrlCourier}vigo-panel/9.jpg`,
    `${config.awsUrlCourier}vigo-panel/10.jpg`,
];

export const LoginBackground = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
            const promises = backgroundImages.map((src) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.src = src;
                    img.onload = resolve;
                    img.onerror = reject;
                });
            });
            
            Promise.all(promises)
                .then(() => setIsLoaded(true))
                .catch(err => console.error("Resim yüklenirken hata oluştu:", err));
        
    }, []);

    useEffect(() => {
        if (isLoaded) {
            const interval = setInterval(() => {
                const nextIndex = (currentImageIndex + 1) % backgroundImages.length;
                setCurrentImageIndex(nextIndex);
            }, 8000); 
            
            return () => clearInterval(interval);
        }
    }, [isLoaded, currentImageIndex])
    
    return (
        <BackgroundContainer>
            <LoginImage>
                {
                    backgroundImages.map((image, index) => (
                        <LoginImageWrapper
                            key={index} 
                            isActive={index === currentImageIndex}
                        >
                            <img src={image} alt="Login Background" />
                        </LoginImageWrapper>
                    ))
                }
            </LoginImage>
        </BackgroundContainer>
    );
};
